import {observer} from 'mobx-react';
import React from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown} from 'reactstrap';
import {X8Block, userStatusService} from '../../../../domain';
import {X7PushableBlockStore} from '../X7PushableBlockStore';
import {BlockMode} from './X8BlockComponent';

type Props = {
  mode: BlockMode,
  block: X8Block,
  store: X7PushableBlockStore,
  headerContent?: (() => React.ReactNode),
}

@observer
export class X8BlockCardHeader extends React.Component<Props> {
  state = {
    bal: this.props.block.Bal
  };

  changeBal= (event: React.ChangeEvent<HTMLInputElement>) =>  {
    event.preventDefault();
    var self = this;
    this.setState({bal: parseInt(event.target.value) });      
  }
  render() {
    const {mode, block, store} = this.props;
    const blockId = block.Id;
    const items = block.Items!;
    const showHeaderActions = mode === 'view-with-actions';
    const showHeaderExamination = block.LessonType === 'Examination'
    const headerContent = this.props.headerContent;

    const anyHeaderActions = showHeaderActions ||
      (headerContent !== undefined);

    return (
      <div className="row">
        <div className="col">
          Block type: {block.BlockType}
          <span className="d-none">mode: {mode}</span>
        </div>
        {
          anyHeaderActions &&
          <div className="col-auto">
            {
              (showHeaderActions  && userStatusService.status.roles.ContentManager)&&
              <UncontrolledButtonDropdown>
                <DropdownToggle caret>
                  Add
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'static-html')}>
                    Static Content
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'static-image')}>
                    Image
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'matching-question')}>
                    Matching Question
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'select-question')}>
                    Select Question
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'gap-filling')}>
                    Gap Filling
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'multiple-choice-question')}>
                    Multiple choice question
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'grouping-exercise')}>
                    Grouping exercise
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'flashcards')}>
                    Flashcards
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'slideshow')}>
                    Slideshow
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'open-ended-question')}>
                    Open ended question
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'open-ended-question-inline')}>
                    Open ended question 2
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'synced-audio')}>
                    Audio
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => store.beginAddContent(blockId, 'synced-video')}>
                    Video
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            }
            {
              (showHeaderActions && userStatusService.status.roles.ContentManager) &&
              <button type="button" className="btn btn-primary"
                      onClick={() => store.beginReorderContents(blockId)}
                      disabled={items.length < 2}>
                Reorder
              </button>
            }
            {
              (showHeaderActions && userStatusService.status.roles.ContentManager) &&
              <button type="button" className="btn btn-danger"
                      onClick={() => store.beginDeleteBlock(blockId)}>
                Delete
              </button>
            }
             {
              showHeaderExamination &&
              <input type="number" value={this.state.bal} onChange={this.changeBal} min={0} />                                      
            }
            {
              showHeaderExamination &&
              <button type="button" className="btn btn-primary"
                 onClick={() => store.beginBalBlock(blockId, this.state.bal, block.BlockType)}>
                  Save bal
                </button>                          
            }                     
            {
              (headerContent !== undefined) &&
              headerContent()
            }
          </div>
        }
      </div>);
  }
}
